module.exports = __webpack_public_path__ + "img/service-resource08.33ea8314.jpg";